import { BotLeftTableNotificationSettings } from './BotLeftTableNotificationSettings';
import { ChatSettings } from './ChatSettings';
import { LivePlayerBetStraddleNotificationSettings } from './LivePlayerBetStraddleNotificationSettings';
import { LivePlayerWonNBBNotificationSettings } from './LivePlayerWonNBBNotificationSettings';
import { NewLivePlayerNotificationSettings } from './NewLivePlayerNotificationSettings';
import { NotificationSettings } from './NotificationSettings';
import { PushNotificationSettings } from './PushNotificationSettings';
import { TableSettings } from './TableSettings';

export interface UserSettings {
  chat: ChatSettings;
  table: TableSettings;
  newLivePlayerNotifications: NewLivePlayerNotificationSettings;
  livePlayerWonNBBNotifications: LivePlayerWonNBBNotificationSettings;
  botLeftTableNotifications: BotLeftTableNotificationSettings;
  livePlayerBetStraddleNotifications: LivePlayerBetStraddleNotificationSettings;
  pushNotifications: PushNotificationSettings;
}

export type NotificationSettingsOption = {
  [K in keyof NotificationSettings]?: NotificationSettings[K];
};

export type TableSettingsOption = {
  [K in keyof TableSettings]?: TableSettings[K];
};

export type ChatSettingsOption = {
  [K in keyof ChatSettings]?: ChatSettings[K];
};

export type PushNotificationOption = {
  [K in keyof PushNotificationSettings]?: PushNotificationSettings[K];
};

export enum NotificationSectionKey {
  CHAT_TEXT = 'chat.textSettings',
  CHAT_EMOJI = 'chat.emojiSettings',
  NEW_LIVE_PLAYER_NOTIFICATIONS = 'newLivePlayerNotifications',
  LIVE_PLAYER_WON_N_BB_NOTIFICATIONS = 'livePlayerWonNBBNotifications',
  BOT_LEFT_TABLE_NOTIFICATIONS = 'botLeftTableNotifications',
  LIVE_PLAYER_BET_STRADDLE_NOTIFICATIONS = 'livePlayerBetStraddleNotifications',
}
